import { render, staticRenderFns } from "./CommissionItem.vue?vue&type=template&id=124f0f86&scoped=true&"
import script from "./CommissionItem.vue?vue&type=script&lang=js&"
export * from "./CommissionItem.vue?vue&type=script&lang=js&"
import style0 from "./CommissionItem.vue?vue&type=style&index=0&id=124f0f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f0f86",
  null
  
)

export default component.exports